export const getters = {
    list: state => state.list,
    columns: state => state.columns,
};
